// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./dashboard.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./profile.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./course-detail.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./quiz.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./settings.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./course-player.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./questions.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Font Awesome for icons */

.auth-container {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.auth-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

/* Logo Styling */
.logo-container {
  margin-bottom: 2rem;
}

.logo-arrows {
  display: inline-block;
  margin-right: 8px;
}

.arrow {
  color: #4fbe6c;
  font-size: 1.5rem;
  font-weight: bold;
  margin-right: 2px;
}

.logo-text {
  display: inline;
  color: #333;
  font-size: 1.8rem;
  font-weight: 600;
}

.tagline {
  font-size: 0.9rem;
  margin-top: 0.25rem;
  color: #666;
}

/* Tab Navigation */
.tab-navigation {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tab-link {
  display: block;
  padding: 12px 20px;
  text-align: center;
  text-decoration: none;
  color: #666;
  background-color: #e9ecef;
  border: none;
  transition: all 0.3s ease;
  font-weight: 500;
}

.tab-link:hover {
  color: #333;
  text-decoration: none;
}

.tab-link.active {
  background-color: #4fbe6c;
  color: white;
  position: relative;
}

.tab-link.active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #4fbe6c;
}

/* Form Styling */
.auth-content {
  padding-top: 1rem;
}

.welcome-message h3 {
  color: #4fbe6c;
  font-weight: 500;
  margin-bottom: 2rem;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #666;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px 15px;
  font-size: 0.95rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-control:focus {
  border-color: #4fbe6c;
  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);
}

.custom-input {
  background-color: #4fbe6c08;
  border: 1px solid #4fbe6c;
}

.custom-input:focus {
  background-color: #4fbe6c08;
  border-color: #4fbe6c;
  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);
}

/* Button Styling */
.custom-btn {
  background-color: #4fbe6c;
  border-color: #4fbe6c;
  padding: 12px 30px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.custom-btn:hover {
  background-color: #4fbe6c;
  border-color: #4fbe6c;
  transform: translateY(-1px);
}

.custom-btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);
}

/* Links */
.text-warning {
  color: #b8860b !important;
}

.text-warning:hover {
  color: #9a7209 !important;
}

/* Info Message */
.info-message {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 1rem;
  border-left: 4px solid #4fbe6c;
}

/* reCAPTCHA Placeholder */
.recaptcha-placeholder {
  min-height: 60px;
  border: 1px solid #ddd !important;
}

.recaptcha-logo {
  width: 40px;
  height: 40px;
  background-color: #f0f0f0;
  border-radius: 4px;
}

/* Form Check */
.form-check-input:checked {
  background-color: #4fbe6c;
  border-color: #4fbe6c;
}

.form-check-input:focus {
  border-color: #4fbe6c;
  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);
}

/* Responsive Design */
@media (max-width: 576px) {
  .auth-card {
    margin: 1rem;
    padding: 1.5rem;
  }

  .auth-card-register {
    margin-top: 330px !important;
  }

  .logo-text {
    font-size: 1.5rem;
  }

  .tab-link {
    padding: 10px 15px;
    font-size: 0.9rem;
  }
}

/* Password Toggle Button */
.btn-link {
  padding: 0;
  border: none;
  background: none;
  color: #dc3545;
  text-decoration: none;
}

.btn-link:hover {
  color: #c82333;
}

.btn-link:focus {
  box-shadow: none;
}


/* share modal */
.share-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  width: 530px;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.share-link input {
  width: 100%;
  padding: 8px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.social-buttons button {
  margin: 5px;
  padding: 10px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.social-buttons button:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAUlC;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Import Font Awesome for icons */\n@import url(\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css\");\n@import \"./dashboard.css\";\n@import \"./profile.css\";\n@import \"./course-detail.css\";\n@import \"./quiz.css\";\n@import \"./settings.css\";\n@import \"./course-player.css\";\n@import \"./questions.css\";\n\n.auth-container {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.auth-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* Logo Styling */\n.logo-container {\n  margin-bottom: 2rem;\n}\n\n.logo-arrows {\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.arrow {\n  color: #4fbe6c;\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-right: 2px;\n}\n\n.logo-text {\n  display: inline;\n  color: #333;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.tagline {\n  font-size: 0.9rem;\n  margin-top: 0.25rem;\n  color: #666;\n}\n\n/* Tab Navigation */\n.tab-navigation {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.tab-link {\n  display: block;\n  padding: 12px 20px;\n  text-align: center;\n  text-decoration: none;\n  color: #666;\n  background-color: #e9ecef;\n  border: none;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.tab-link:hover {\n  color: #333;\n  text-decoration: none;\n}\n\n.tab-link.active {\n  background-color: #4fbe6c;\n  color: white;\n  position: relative;\n}\n\n.tab-link.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #4fbe6c;\n}\n\n/* Form Styling */\n.auth-content {\n  padding-top: 1rem;\n}\n\n.welcome-message h3 {\n  color: #4fbe6c;\n  font-weight: 500;\n  margin-bottom: 2rem;\n}\n\n.form-label {\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  color: #666;\n}\n\n.form-control {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 12px 15px;\n  font-size: 0.95rem;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.form-control:focus {\n  border-color: #4fbe6c;\n  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);\n}\n\n.custom-input {\n  background-color: #4fbe6c08;\n  border: 1px solid #4fbe6c;\n}\n\n.custom-input:focus {\n  background-color: #4fbe6c08;\n  border-color: #4fbe6c;\n  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);\n}\n\n/* Button Styling */\n.custom-btn {\n  background-color: #4fbe6c;\n  border-color: #4fbe6c;\n  padding: 12px 30px;\n  font-weight: 500;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.custom-btn:hover {\n  background-color: #4fbe6c;\n  border-color: #4fbe6c;\n  transform: translateY(-1px);\n}\n\n.custom-btn:focus {\n  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);\n}\n\n/* Links */\n.text-warning {\n  color: #b8860b !important;\n}\n\n.text-warning:hover {\n  color: #9a7209 !important;\n}\n\n/* Info Message */\n.info-message {\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 1rem;\n  border-left: 4px solid #4fbe6c;\n}\n\n/* reCAPTCHA Placeholder */\n.recaptcha-placeholder {\n  min-height: 60px;\n  border: 1px solid #ddd !important;\n}\n\n.recaptcha-logo {\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 4px;\n}\n\n/* Form Check */\n.form-check-input:checked {\n  background-color: #4fbe6c;\n  border-color: #4fbe6c;\n}\n\n.form-check-input:focus {\n  border-color: #4fbe6c;\n  box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);\n}\n\n/* Responsive Design */\n@media (max-width: 576px) {\n  .auth-card {\n    margin: 1rem;\n    padding: 1.5rem;\n  }\n\n  .auth-card-register {\n    margin-top: 330px !important;\n  }\n\n  .logo-text {\n    font-size: 1.5rem;\n  }\n\n  .tab-link {\n    padding: 10px 15px;\n    font-size: 0.9rem;\n  }\n}\n\n/* Password Toggle Button */\n.btn-link {\n  padding: 0;\n  border: none;\n  background: none;\n  color: #dc3545;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  color: #c82333;\n}\n\n.btn-link:focus {\n  box-shadow: none;\n}\n\n\n/* share modal */\n.share-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n  width: 530px;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.share-link input {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.social-buttons button {\n  margin: 5px;\n  padding: 10px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.social-buttons button:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
